
/* eslint-disable */
/* Note: this code is generated by generateSizingEnums.js, do not modify it */
import React from 'react'
import PropTypes from 'prop-types'

class FeatureDescriptionTranslate extends React.Component {
	render() {
		const descriptions = {
			"ACCESSORIES": {
				"ACCESSORIES": this.context.translate("Used to contribute in a secondary manner to the item or kit it relates to  often used to complete an outfit and chosen to specifically complement the wearers look The term came into use in the 20th century")
			},
			"AESTHETIC": {
				"AESTHETIC": this.context.translate("Look and feel visual design")
			},
			"BREATHABLE": {
				"BREATHABLE": this.context.translate("Material that admits air to the skin and allows sweat to evaporate")
			},
			"CABLE-MANAGEMENT": {
				"CABLE-MANAGEMENT": this.context.translate("Ability to route cables through garments or equipment so that they are protected and or hidden ")
			},
			"CHAMOIS": {
				"CHAMOIS": this.context.translate("An absorbant seat pad attached to a garment Designed to reduce friction wick moisture and improve rider comfort")
			},
			"CLOSURE": {
				"CLOSURE": this.context.translate("A system that allows an item to be opened or closed eg zippers or drawstrings"),
				"ZIPPER": this.context.translate("A zipper zip fly or zip fastener formerly known as a clasp locker is a commonly used device for binding the edges of an opening of fabric or other flexible material such as on a garment or a bag"),
				"HIDDEN-ZIPPER": this.context.translate("A hidden zipper zip fly or zip fastener"),
				"LACES": this.context.translate("A fastening for footwear and some bags and gloves that allows for very specific adjustability and good fit Generally replaceable "),
				"SLIP-ON": this.context.translate("No fastenings are required to use the item")
			},
			"COMFORT": {
				"COMFORT": this.context.translate("A measure of how physically comfortable something is Is it possible to use the item as intended without undue discomfort pain or irritation "),
				"PADDING": this.context.translate("Provides protection from impacts and pressure "),
				"SEAMLESS-CONSTRUCTION": this.context.translate("There are no seams and as a result no possible irritation")
			},
			"COMPACT": {
				"COMPACT": this.context.translate("This item is physically smaller than equivalent items of its type")
			},
			"COMPRESSION": {
				"COMPRESSION": this.context.translate("Provides extra compressive support when worn or used")
			},
			"CONNECTIVITY": {
				"MODULAR": this.context.translate("Ability to add remove or replace parts of the item without damaging it so it can perform as required ")
			},
			"CONSTRUCTION-DETAIL": {
				"FLATLOCK-STITCHING": this.context.translate("Commonly used to attach fabrics together side-by-side in one layer rather than layered with a thick seam"),
				"ONE-PIECE-DESIGN": this.context.translate("Fewer seams and joins for improved appearance durability and comfort"),
				"LASER-CUT-HEM": this.context.translate("Finely cut hem creates a sharp line "),
				"EMBROIDERED-DETAILING": this.context.translate("Embroidered Detailing")
			},
			"DESIGN-LENGTH": {
				"HIGH-RISE-CUFF": this.context.translate("Sock that reaches to the calf muscle generally about 7 inches long"),
				"KNEE-LENGTH": this.context.translate("Meets the knee either from the waist or ankle"),
				"LONG-SLEEVE": this.context.translate("Full length arm covering from shoulder to wrist"),
				"MEDIUM-SLEEVE": this.context.translate("A sleeve length that reaches past the elbow but not all the way to the wrist"),
				"EXTENDED-SHORT-SLEEVE": this.context.translate("A sleeve length that reaches roughly 34 of the way from the shoulder to the elbow and covers the bicep"),
				"MID-SOCK-HEIGHT": this.context.translate("Socks that end just above the ankle"),
				"LOW-SOCK-HEIGHT": this.context.translate("Socks that end just below the ankle"),
				"HIGH-SOCK-HEIGHT": this.context.translate("Sock that reaches to the calf muscle generally about 7 inches long UCI regulations state no higher than mid-point between the ankle and the knee"),
				"SHORT-SLEEVE": this.context.translate("Sleeve length is mid bicep"),
				"BODY": this.context.translate("The item has no sleeves"),
				"SLEEVELESS": this.context.translate("The item has no sleeves")
			},
			"DURABLE": {
				"DURABLE": this.context.translate("This item is designed to resist wear and damage when used"),
				"MATERIALS": this.context.translate("An item that is constructed of heavier or stronger materials that will more likely resist wear and damage "),
				"RIP-PREVENTION": this.context.translate("Weave type that stops a rip from propogating once a tear occurs ")
			},
			"EAR-COVER": {
				"EAR-COVER": this.context.translate("Keeps your ears covered for greater warmth")
			},
			"FIT": {
				"ONE-SIZE-FITS-ALL": this.context.translate("One Size Fits All"),
				"ADJUSTABLE-FIT": this.context.translate("Ability to adjust the fit to meet specific personal needs For example adjustable straps or belts "),
				"CLOSE-FITTED": this.context.translate("Garment is fitted tightly to the body but not skin tight"),
				"MEDIUM-FIT": this.context.translate("A fit that is not form fitting but not baggy or loose "),
				"WOMENS-FIT": this.context.translate("A fit that is specifically designed for women"),
				"SKIN-TIGHT-RACE-FIT": this.context.translate("Garment fits extremely tightly to the body is skin tight for maximum aerodynamics"),
				"RELAXED-FIT": this.context.translate("Loose or baggy as designed Hides the shape of the body ")
			},
			"GRIPPER": {
				"LEG-GRIPPER": this.context.translate("Creates adhesion on leg so that it doesnt move around in use "),
				"ARM-GRIPPER": this.context.translate("Creates adhesion on arm so that it doesnt move around in use "),
				"WAIST-GRIPPER": this.context.translate("Creates adhesion at waist so that it doesnt move around in use ")
			},
			"INSULATION": {
				"INSULATION": this.context.translate("Material that prevents the loss of heat or intrusion of sound")
			},
			"LENS": {
				"ANTI-FOG": this.context.translate("Reduced or no fogging of lens"),
				"LOW-LIGHT": this.context.translate("Improves vision in low light"),
				"BRIGHT-LIGHT": this.context.translate("Improves vision in bright light"),
				"VARIABLE": this.context.translate("Improves vision in changing conditions"),
				"SNOW": this.context.translate("Improves vision for snowy conditions"),
				"CLEAR": this.context.translate("Improves vision in low light by providing eye protection from wind and foreign objects")
			},
			"LENS-WIPE": {
				"WIPING-SURFACE": this.context.translate("Surface for wiping goggle or glasses lens to defog or remove water")
			},
			"LIGHTWEIGHT": {
				"LIGHT": this.context.translate("Of thin material or build and weighing less than average objects of similar type "),
				"PACKABLE": this.context.translate("Easy to carry along with you generally refers to something that can compress down to a small size and is lightweight")
			},
			"LOW-PROFILE": {
				"LOW-PROFILE": this.context.translate("Thin and uniform to avoid obstruction andor improve aerodynamics")
			},
			"MATERIAL-QUALITY": {
				"HIGH-QUALITY": this.context.translate("The overall quality of the materials used High quality materials tend to look and feel better be thickerstronger and more durable Low quality materials do not perform as well and tend to wear out easily  ")
			},
			"MOUNTS": {
				"BELT-LOOPS": this.context.translate("Belt loops to hold a belt in place"),
				"CAMERA-MOUNT": this.context.translate("Attachment for a camera"),
				"CLEAT-MOUNT": this.context.translate("Attachment for a pedal cleat or other mount"),
				"EYEWEAR-INTEGRATION": this.context.translate("A mechanism that allows attachment of eyewear either as a part of the actual helmet such as a visor or within a storage space "),
				"LIGHTS-MOUNT": this.context.translate("Attachment for torch or bike light"),
				"MOUNTS": this.context.translate("Attachment mounts for equipment"),
				"MOLDED-SPD-COMPATIBLE-SHANK": this.context.translate("Mounting system that allows for an SPD Cleat")
			},
			"NOISE": {
				"LOUD": this.context.translate("Generates more noise than other items of similar type"),
				"QUIET": this.context.translate("Generates less noise than other items of similar type")
			},
			"ODOR-RESISTANT": {
				"ANTI-MICROBIAL": this.context.translate("Kills or stops the growth of microorganisms in order to stop the resulting odor that can be generated ")
			},
			"PERFORMANCE": {
				"AERODYNAMIC": this.context.translate("Designed to reduce the drag from air moving past"),
				"GRIP-TRACTION": this.context.translate("Measure of how well something sticks to the road handlebars handle and so on")
			},
			"POCKET": {
				"INTERNAL-POCKETS": this.context.translate("A small bag sewn into or on clothing so as to form part of it used for carrying small articles"),
				"EXTERNAL-POCKETS": this.context.translate("A small bag sewn into or on clothing so as to form part of it used for carrying small articles"),
				"DEVICE-POCKET": this.context.translate("Protects device with soft or padded lining"),
				"CYCLING-CARGO-POCKETS": this.context.translate("Typical pockets for a cycling jersey allow for storage of layers gloves food and accessories")
			},
			"PONY-TAIL-COMPATIBLE": {
				"PONYTAIL-COMPATIBLE": this.context.translate("Possible to comfortably wear this item with a ponytail")
			},
			"PROTECTION": {
				"OUTER-SHELL": this.context.translate("External layer that provides things like protection durability water resistance"),
				"ARMOR": this.context.translate("Hard exterior surface and padded interior that protects against damage buy deflecting and absorbing impact energy"),
				"HEAT-REFLECTIVE": this.context.translate("Reflects heat away to keep wearer or contents cooler"),
				"EPS-LINER": this.context.translate("Lightweight Expanded Polystyrene padding that crushesdeforms on impact and absorbs damage to protect your headequipment"),
				"EYE-PROTECTION": this.context.translate("Protective gear for the eyes protecting from things like particles light wind blast heat sea spray or some type of ball or puck used in sports")
			},
			"QUICK-DRY": {
				"ANTI-FOG": this.context.translate("Surface is treated to prevent the condensation of water in the form of small droplets which resemble fog"),
				"QUICK-DRY": this.context.translate("Quick Dry fabric type")
			},
			"RANGE": {
				"RANGE": this.context.translate("Distance that item can travel and still function")
			},
			"RECYCLED": {
				"RECYCLED-MATERIAL": this.context.translate("Material used in the construction was recycled")
			},
			"SAFETY": {
				"GRIP": this.context.translate("Traction when required")
			},
			"SHOE-INSOLE": {
				"SHOE-INSOLE": this.context.translate("Interior bottom of a shoe which sits directly beneath the foot under the footbed also known as sock liner")
			},
			"SHOE-SOLE": {
				"SHOE-SOLE": this.context.translate("The bottom of a boot or shoe in contact with the ground or cleat that can provide additional stiffness or cushioning ")
			},
			"SHOE-UPPER": {
				"SHOE-UPPER": this.context.translate("The part of a boot or shoe above the sole")
			},
			"STRETCH": {
				"FOUR-WAY-STRETCH": this.context.translate("Four-way Stretch 4-way stretch fabrics such as spandex stretch in both directions crosswise and lengthwise"),
				"STRETCH": this.context.translate("Stretches for comfort and performance"),
				"TWO-WAY-STRETCH": this.context.translate("Two-way Stretch 2-way stretch fabrics stretch in one direction across the knit")
			},
			"SUN-PROTECTION": {
				"UPF-20": this.context.translate("Good sun protection 933 - 959 of UV radiation blocked"),
				"UPF-25": this.context.translate("Very good sun protection 96 - 974 of UV radiation blocked"),
				"UPF-30": this.context.translate("Very good sun protection 96 - 974 of UV radiation blocked"),
				"UPF-40": this.context.translate("Excellent sun protection 975 - 98+ of UV radiation blocked"),
				"UPF-50": this.context.translate("Excellent sun protection 975 - 98+ of UV radiation blocked")
			},
			"SUPPORT": {
				"SUPPORT": this.context.translate("Provides physical support ")
			},
			"SUSTAINABLE": {
				"SUSTAINABLE": this.context.translate("Sustainably manufactured")
			},
			"TOUCH-SCREEN-COMPATIBLE": {
				"SCREEN-COMPATIBLE": this.context.translate("Allows use of a touch screen")
			},
			"VENTILATION": {
				"MESH-MATERIAL": this.context.translate("Lightweight material that has small holes for better airflow "),
				"VENTILATION": this.context.translate("Enables air flow to improve thermal regulation remove excess sweat and avoid heat stress")
			},
			"VISIBILITY": {
				"HIGH-VISIBILITY": this.context.translate("Either an extremely visible color such as Neon or very reflective "),
				"REFLECTIVE": this.context.translate("Reflects light back to the source and is highly visible at night ")
			},
			"WARM-WEATHER": {
				"SUMMER": this.context.translate("Designed to be breathable in hot weather")
			},
			"WATER-RESISTANT": {
				"WATER-RESISTANT": this.context.translate("Is able to resist the penetration of water to some degree but not entirely")
			},
			"WATERPROOF": {
				"SEALED-SEAMS": this.context.translate("Seams are taped or glued to prevent water from leaking through "),
				"WATERPROOF": this.context.translate("Is relatively unaffected by water and prevents the ingress of water under specified conditions")
			},
			"WICKING": {
				"POLARTEC-POWER-DRY-FABRIC": this.context.translate("Moisture wicking fabric type"),
				"WICKING": this.context.translate("Uses technical synthetic fabrics to speed moisture transfer away from the body allow it to evaporate and keep you dry")
			},
			"WINDPROOF": {
				"WINDPROOF": this.context.translate("Provides protection from the wind")
			}
		}
		let { type, subTypes } = this.props
		type = type? type.toUpperCase(): ''
        let desc = []
		subTypes = subTypes || []

        subTypes.forEach((st)=>{
			if(st.type) {
				const mySubType = st.type.toUpperCase()
				if(descriptions[type] && descriptions[type][mySubType] ) {
					desc.push(descriptions[type][mySubType])
				}
			}
			if(st.originalName) {
				desc.push(st.originalName)
			}
		})
		return <span>{desc.join("\n")}</span>
    }
}

FeatureDescriptionTranslate.propTypes = {
	type: PropTypes.string.isRequired,
	subTypes: PropTypes.array
}

FeatureDescriptionTranslate.defaultProps = {
	subTypes: []
}

FeatureDescriptionTranslate.contextTypes = {
	translate: PropTypes.func
}

export default FeatureDescriptionTranslate



// WEBPACK FOOTER //
// ./src/components/FeatureDescriptionTranslate.jsx